<template>
  <div class="flex flex-col sm:flex-row gap-3 mb-6 items-stretch sm:items-center justify-between">
    <!-- Buscador Principal -->
    <div class="relative flex-1">
      <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400">
        <i class="fa fa-search text-sm" />
      </div>
      <input 
        :value="search"
        type="text"
        class="block w-full pl-10 pr-10 py-2.5 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 placeholder-gray-400 transition-all shadow-sm text-sm" 
        placeholder="Buscar cliente por nombre, empresa o documento..." 
        @input="$emit('update:search', $event.target.value)"
      />
      <button 
        v-if="search" 
        type="button"
        class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
        @click="$emit('update:search', '')"
      >
        <i class="fa fa-times-circle text-sm" />
      </button>
    </div>

    <!-- Quick Status Filter Pills -->
    <div class="flex items-center gap-1.5 overflow-x-auto pb-1 sm:pb-0">
      <button
        type="button"
        class="px-3.5 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors shadow-xs"
        :class="!status ? 'bg-orange-500 text-white' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'"
        @click="$emit('update:status', '')"
      >
        Todos
      </button>
      <button
        type="button"
        class="px-3.5 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors shadow-xs"
        :class="status === 'with_debt' ? 'bg-orange-500 text-white' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'"
        @click="$emit('update:status', 'with_debt')"
      >
        Con saldo pendiente
      </button>
      <button
        type="button"
        class="px-3.5 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors shadow-xs"
        :class="status === 'up_to_date' ? 'bg-orange-500 text-white' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'"
        @click="$emit('update:status', 'up_to_date')"
      >
        Al día
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientFilters',

  props: {
    search: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
  },

  emits: ['update:search', 'update:status', 'reset'],
}
</script>
